import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import styled from 'styled-components';
import {
  Button,
  Select,
  Modal,
  Input,
  Dropdown,
  Confirm
} from 'semantic-ui-react';
import _ from 'lodash';

import { getPages } from '../../fbApi/Page';
import { getAccounts } from '../../services/AccountService';
import { Lob, Loader } from '../../components/share';
import domains from '../../containers/Domains';
import * as AppActions from '../../actions';

import facebookIcon from '../../assets/images/facebook-icon.png';

const Container = styled.div`
  overflow-x: hidden;
`;
const ListContainer = styled.div`
  max-width: 768px;
  margin: 20px 0 0 0;
`;
const PlatformItem = styled.div`
  display: flex;
  flex: 0.4;
  flex-direction: row;
  align-items: center;
`;
const Logo = styled.img`
  height: 18px;
  margin-right: 5px;
`;
const TextItem = styled.span`
  color: #121212;
  font-size: 16px;
`;
const TextError = styled.span`
  color: #db2828;
  font-size: 16px;
  margin-top: 10px;
  display: block;
`;
const SelectCustom = styled(Select)`
  width: 100%;
  margin: 00;
`;
const LoaderContainer = styled.div`
  position: relative;
  max-width: 768px;
`;

class AdShareSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      openModal: false,
      openModalAds: false,
      modalLob: false,
      modalAccount: false,
      modalMessage: false,
      confirmDeleteLob: false,
      facebookPages: [],
      facebookAds: [],
      facebookPageId: null,
      facebookAdId: null,
      facebookUserId: null,
      facebookToken: null,
      lobs: {},
      lobName: '',
      lobId: '',
      accountType: null,
      errorMessage: ''
    };
  }

  componentDidMount = async () => {
    const { actions, location, user } = this.props;
    await actions.fetchLob(user.sub);
    const selectedAccountType = localStorage.getItem('SelectedAccountType');
    const selectedLobId = localStorage.getItem('SelectedLobId');

    if (location && location.search.length > 0) {
      const search = location.search.split('?code=');
      const code = search[1];

      if (selectedAccountType === 'instagram') {
        const instagramData = await this.getInstagramData(code);
        if (instagramData.data && instagramData.data.user) {
          instagramData.data.type = 'instagram';
          instagramData.data.lob = selectedLobId;
          await actions.insertLobAccount(instagramData.data);
          localStorage.removeItem('SelectedAccountType');
          localStorage.removeItem('SelectedLobId');
          actions.fetchLob(user.sub);
        }
      }
    }
  };

  getAdAccounts = async () => {
    try {
      this.setState({ modalAccount: true, loading: true });
      const result = await getAccounts();
      if (result) {
        const accountOptions = _.sortBy(
          _.map(result, (op) => op),
          'name'
        );
        this.setState({
          facebookAds: accountOptions,
          facebookToken: 'none',
          facebookUserId: 'none',
          modalAccount: false,
          loading: false,
          openModalAds: true
        });
      }
    } catch (e) {
      this.setState({ modalAccount: false, loading: false });
      console.log(e.response);
    }
  };

  getPageAccounts = async () => {
    try {
      this.setState({ modalAccount: true, loading: true });
      const pages = await getPages(this.props.getFbToken());
      if (pages.length > 0) {
        const filteredPages = pages[0].data
          .concat(pages[1].data)
          .filter((page) => page.access_token);
        const pagesOptions = _.sortBy(
          _.map(filteredPages, (page) => page),
          'name'
        );
        this.setState({
          facebookPages: pagesOptions,
          facebookToken: 'none',
          facebookUserId: 'none',
          modalAccount: false,
          loading: false,
          openModal: true
        });
      }
    } catch (e) {
      this.setState({ modalAccount: false, loading: false });
    }
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  closeModalAds = () => {
    this.setState({ openModalAds: false });
  };

  getPageName = () => {
    const { facebookPages, facebookPageId } = this.state;
    const selected = facebookPages.filter((page) => page.id === facebookPageId);

    return selected[0].name;
  };

  getAdName = () => {
    const { facebookAds, facebookAdId } = this.state;
    const selected = facebookAds.filter((ad) => ad.account_id === facebookAdId);

    return selected[0].name;
  };

  lobNameToKey = (str) => {
    return str.replace(/ /g, '_');
  };

  existLob = (lobs) => {
    let result = false;
    Object.keys(lobs).forEach((key) => {
      if (lobs[key].name === this.state.lobName) result = true;
    });
    return result;
  };

  toggleModalLob = () => {
    this.setState({ modalLob: !this.state.modalLob });
  };

  toggleModalAccount = () => {
    this.setState({ modalAccount: !this.state.modalAccount });
  };

  toggleModalMessage = () => {
    this.setState({ modalMessage: !this.state.modalMessage });
  };

  toggleConfirmDeleteLob = () => {
    this.setState({ confirmDeleteLob: !this.state.confirmDeleteLob });
  };

  onConfirmDeleteLob = () => {
    this.toggleConfirmDeleteLob();
    this.props.actions.removeLob(this.state.lobId);
  };

  addLob = () => {
    const { actions, adShare, user } = this.props;
    if (!this.existLob(adShare.lobs)) {
      actions.insertLob(this.state.lobName, user.sub);
      this.setState({ errorMessage: '', modalLob: false, lobName: '' });
    } else {
      this.setState({ errorMessage: 'This name already exist' });
    }
  };

  addAccount = (lobId) => {
    localStorage.setItem('SelectedLobId', lobId);
    this.setState({ lobId, modalAccount: true });
  };

  removeAccount = (lobId, accountId) => {
    this.props.actions.removeAccount(lobId, accountId);
  };

  onDeleteLob = (lobId) => {
    this.setState({ confirmDeleteLob: true, lobId });
  };

  logoutInstagram = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
      this.props.history.push('/share/settings');
      return false;
    }, 1000);
  };

  getInstagramData = async (code) => {
    try {
      return await axios(
        `${domains[window.location.hostname]}instagram?code=${code}&base_url=${
          window.location.origin
        }`
      );
    } catch (e) {
      console.log(e.response);
      return null;
    }
  };

  logoutFacebook = () => {
    this.setState({ loading: true, openModal: false, openModalAds: false });
    setTimeout(() => {
      this.setState({
        facebookPages: [],
        facebookPageId: null,
        facebookAds: [],
        facebookAdId: null,
        loading: false
      });
      this.props.history.push('/share/settings');
      return false;
    }, 1000);
  };

  getFacebookData = async (code, selectedAccountType) => {
    try {
      const type = selectedAccountType === 'facebook' ? 'pages' : 'ads';
      return await axios(
        `${
          domains[window.location.hostname]
        }facebook?code=${code}&type=${type}&base_url=${window.location.origin}`
      );
    } catch (e) {
      console.log(e.response);
      return null;
    }
  };

  onChangePage = (facebookPageId) => {
    this.setState({ facebookPageId });
  };

  onChangeAd = (facebookAdId) => {
    this.setState({ facebookAdId });
  };

  onConfirmPage = async () => {
    try {
      this.setState({ loading: true });
      const { facebookPageId, facebookUserId, facebookToken } = this.state;
      const { actions, user } = this.props;
      const selectedLobId = localStorage.getItem('SelectedLobId');

      const payload = {
        lob: selectedLobId,
        access_token: facebookToken,
        type: 'facebook',
        page: facebookPageId,
        user: {
          id: facebookUserId,
          username: this.getPageName()
        }
      };

      await actions.insertLobAccount(payload);
      localStorage.removeItem('SelectedAccountType');
      localStorage.removeItem('SelectedLobId');
      actions.fetchLob(user.sub);
      this.setState({ openModal: false, loading: false });
    } catch (e) {
      this.setState({ loading: false });
      console.log(e.response);
    }
  };

  onConfirmAd = async () => {
    try {
      this.setState({ loading: true });
      const { facebookAdId, facebookUserId, facebookToken } = this.state;
      const { actions, user } = this.props;
      const selectedLobId = localStorage.getItem('SelectedLobId');

      const payload = {
        lob: selectedLobId,
        access_token: facebookToken,
        type: 'facebookAd',
        page: facebookAdId,
        user: {
          id: facebookUserId,
          username: this.getAdName()
        }
      };

      await actions.insertLobAccount(payload);
      localStorage.removeItem('SelectedAccountType');
      localStorage.removeItem('SelectedLobId');
      actions.fetchLob(user.sub);
      this.setState({ openModalAds: false, loading: false });
    } catch (e) {
      this.setState({ loading: false });
      console.log(e.response);
    }
  };

  onChangeAccountType = (accountType) => {
    localStorage.setItem('SelectedAccountType', accountType);
    this.setState({ accountType });
  };

  onAddAccount = () => {
    const { actions } = this.props;
    const { accountType } = this.state;

    if (accountType === 'null' || accountType === null) {
      this.setState({ errorMessage: 'Please select an account type' });
    } else {
      if (accountType === 'instagram') {
        actions.loginInstagram();
      } else if (accountType === 'facebook') {
        this.getPageAccounts();
      } else if (accountType === 'facebookAd') {
        this.getAdAccounts();
      }
      this.setState({ errorMessage: '' });
    }
  };

  renderSelectPage = () => {
    const { facebookPages, facebookPageId } = this.state;
    let options = [];
    if (facebookPages.length > 0) {
      options = facebookPages.map((page) => {
        return { key: page.id, value: page.id, text: page.name };
      });
    }

    if (options.length > 0) {
      const valueProps = {};

      if (facebookPageId !== null) {
        valueProps.value = facebookPageId;
      }

      return (
        <Dropdown
          search
          selection
          options={options}
          placeholder="Select Your Facebook Page"
          onChange={(ev, data) => this.onChangePage(data.value)}
          {...valueProps}
        />
      );
    }

    return null;
  };

  renderSelectAds = () => {
    const { facebookAds, facebookAdId } = this.state;
    let options = [];
    if (facebookAds.length > 0) {
      options = facebookAds.map((ad) => {
        return { key: ad.account_id, value: ad.account_id, text: ad.name };
      });
    }

    if (options.length > 0) {
      const valueProps = {};

      if (facebookAdId !== null) {
        valueProps.value = facebookAdId;
      }

      return (
        <Dropdown
          search
          selection
          options={options}
          placeholder="Select Account"
          onChange={(ev, data) => this.onChangeAd(data.value)}
          {...valueProps}
        />
      );
    }

    return null;
  };

  renderLobs = () => {
    const { lobs, loading } = this.props.adShare;

    if (loading) {
      return (
        <LoaderContainer className="preview-container">
          <Loader inverted active />
        </LoaderContainer>
      );
    }

    return (
      <ListContainer>
        {Object.keys(lobs).map((key) => {
          return (
            <Lob
              key={key}
              id={key}
              name={lobs[key].name}
              items={lobs[key].accounts}
              addAccount={this.addAccount}
              removeAccount={this.removeAccount}
              onDelete={this.onDeleteLob}
              loading={loading}
            />
          );
        })}
      </ListContainer>
    );
  };

  render() {
    const { accountType } = this.state;
    const accountTypes = [
      { key: 'instagram', value: 'instagram', text: 'Instagram Account' },
      { key: 'facebook', value: 'facebook', text: 'Facebook Page Account' },
      { key: 'facebookAd', value: 'facebookAd', text: 'Facebook Ad Account' }
    ];
    const typesProps = {};
    if (accountType !== 'null' || accountType !== null) {
      typesProps.value = accountType;
    }

    return (
      <Container className="container">
        <h2>LOB Manager</h2>
        <Button
          primary
          icon="plus"
          labelPosition="right"
          content="New LOB"
          onClick={() => this.toggleModalLob()}
        />
        {this.renderLobs()}
        <Confirm
          open={this.state.confirmDeleteLob}
          header="LOB Manager"
          content="Are you sure to delete this LOB?"
          onCancel={this.toggleConfirmDeleteLob}
          onConfirm={this.onConfirmDeleteLob}
        />
        <Modal
          className="modalFacebookPages"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.openModal}
          onClose={this.closeModal}
        >
          <Modal.Header>
            <PlatformItem>
              <Logo src={facebookIcon} className="ui" alt="Facebook" />
              <TextItem>Facebook</TextItem>
            </PlatformItem>
          </Modal.Header>
          <Modal.Content>{this.renderSelectPage()}</Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.logoutFacebook()} negative>
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Confirm"
              loading={this.state.loading}
              onClick={() => this.onConfirmPage()}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="modalFacebookPages"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.openModalAds}
          onClose={this.closeModalAds}
        >
          <Modal.Header>
            <PlatformItem>
              <Logo src={facebookIcon} className="ui" alt="Facebook" />
              <TextItem>Facebook</TextItem>
            </PlatformItem>
          </Modal.Header>
          <Modal.Content>{this.renderSelectAds()}</Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.logoutFacebook()} negative>
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Confirm"
              loading={this.state.loading}
              onClick={() => this.onConfirmAd()}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="modalFacebookPages"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.modalLob}
          onClose={this.toggleModalLob}
        >
          <Modal.Header>
            <TextItem>LOB Manager</TextItem>
          </Modal.Header>
          <Modal.Content>
            <Input
              className="fluid"
              placeholder="LOB name"
              value={this.state.lobName}
              onChange={(ev) => this.setState({ lobName: ev.target.value })}
            />
            <TextError>{this.state.errorMessage}</TextError>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.toggleModalLob()} negative>
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Add"
              onClick={() => this.addLob()}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="modalFacebookPages"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.modalAccount}
          onClose={this.toggleModalAccount}
        >
          <Modal.Header>
            <TextItem>Add New Account</TextItem>
          </Modal.Header>
          <Modal.Content>
            <SelectCustom
              label=""
              options={accountTypes}
              placeholder="Select Account Type"
              onChange={(ev, data) => this.onChangeAccountType(data.value)}
              {...typesProps}
            />
            <TextError>{this.state.errorMessage}</TextError>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.toggleModalAccount()} negative>
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Add"
              loading={this.state.loading}
              onClick={() => this.onAddAccount()}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          className="modalFacebookPages"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.modalMessage}
          onClose={this.toggleModalMessage}
        >
          <Modal.Header>
            <TextItem>LOB MAnager</TextItem>
          </Modal.Header>
          <Modal.Content>
            <TextError>{this.state.errorMessage}</TextError>
          </Modal.Content>
          <Modal.Actions>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Ok"
              onClick={() => {
                this.toggleModalMessage();
                this.setState({ errorMessage: '' });
              }}
            />
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adShare: state.adShare
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdShareSettings);



// WEBPACK FOOTER //
// ./src/screens/AdShare/Settings.js